import Vue from "vue";
import Router from "vue-router";
import store from "@/store";

// :: Global Views
const Nav = () => import("@/views/Nav");
const Login = () => import("@/views/Login");
const ResetPassword = () => import("@/views/ResetPassword");
const NotFound = () => import("@/views/NotFound");
const UsersAndPermissions = () => import("@/views/UsersAndPermissions");
const UsersEdit = () => import("@/views/UsersEdit");
const Tutorials = () => import("@/views/Tutorials");
// :: Damage Viewsºº
const DamageDashboard = () => import("@/views/damage/Dashboard");
const IndicadoresKPI = () => import("@/views/damage/IndicadoresKPI");
const Search = () => import("@/views/damage/pedidos/DetallePedido");
const SearchBySerie = () => import("@/views/damage/pedidos/DetalleSeries");
const DamagePedidos = () => import("@/views/damage/pedidos/Pedidos");
const Transfers = () => import("@/views/damage/transfers/Transfers");
const Analytics = () => import("@/views/analytics/AnalyticsGlobal");
const Transfer = () => import("@/views/damage/transfers/TransferDetail");
const TransferCheckList = () => import("@/views/damage/transfers/CheckList");
const CompletedChecklist = () => import("@/views/analytics/ListCompleted");
const DamagesChecklist = () => import("@/views/analytics/ListDamages");
const DamageDetallePedido = () =>
  import("@/views/damage/pedidos/DetallePedido");
const AlbaranChecklist = () => import("@/views/damage/albaran/Checklist");
const DamageChecklist = () => import("@/views/damage/pedidos/Checklist");
const DamageContract = () => import("@/views/damage/Contract");
const DamageSignChecklistTransportist = () =>
  import("@/views/damage/SignChecklistTransportist");
const DamageSignChecklistReceptor = () =>
  import("@/views/damage/SignChecklistReceptor");
// :: Dynamic Board Views
const DynBoardsMain = () => import("@/views/dynamic-board/Main");
const History = () => import("@/views/history/GeneralHistory");
const AddKpi = () => import("@/views/carousel/AddKpi");

const routes = [
  {
    // :: TODO ::
    // :: Make a decision on which will be the home page of the application
    // :: For now, the homepage it's the damage dashboard
    // :: just to fix the 404 error when the page is in the root path
    path: "/",
    name: "home",
    component: DamageDashboard,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/login",
    name: "login",
    component: Login
  },
  {
    path: "/reset-password",
    name: "resetPassword",
    component: ResetPassword
  },
  {
    path: "/nav",
    name: "nav",
    component: Nav,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/user-permissions",
    name: "usersAndPermissions",
    component: UsersAndPermissions,
    meta: {
      requiresAuth: true,
      requireAdmin: true
    }
  },
  {
    path: "/tutoriales",
    name: "tutorials",
    component: Tutorials
  },
  {
    path: "/user-permissions/:id/:action",
    name: "usersAndPermissionsActions",
    component: UsersAndPermissions,
    meta: {
      requiresAuth: true,
      requireAdmin: true
    },
    props: true
  },
  {
    path: "/user-permissions/list",
    name: "usersEdit",
    component: UsersEdit,
    meta: {
      requiresAuth: true,
      requireAdmin: true
    }
  },
  // :: Dynamic Board Routes
  {
    path: "/dynamic-board",
    name: "dynamic-board-main",
    component: DynBoardsMain,
    meta: {
      requiresAuth: true,
      requiresValidAccessGlobal: true
    }
  },
  {
    path: "/dynamic-board/:branchOffice",
    name: "dynamic-board-branch",
    component: DynBoardsMain,
    meta: {
      requiresAuth: true,
      requiresValidAccess: true
    }
  },
  // :: Damage Routes
  {
    path: "/carousel-add-kpi",
    name: "AddKpi",
    component: AddKpi,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/incidencias/",
    name: "dashboard",
    component: DamageDashboard,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/carousel-show-kpi",
    name: "ShowKpi",
    component: IndicadoresKPI,
    meta: {
      requiresAuth: true,
      requiresValidAccess: true
    }
  },
  {
    path: "/incidencias/pedidos/busqueda/:orderNumber/:orderType",
    name: "search",
    component: Search,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/incidencias/series/busqueda/:seriesID",
    name: "searchBySerie",
    component: SearchBySerie,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/incidencias/pedidos/:filter",
    name: "pedidos-filter",
    component: DamagePedidos,
    meta: {
      requiresAuth: true,
      requiresValidAccess: true
    }
  },
  {
    path: "/transferencias/pedidos",
    name: "transfers",
    component: Transfers,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/analiticos",
    name: "analytics",
    component: Analytics,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/analiticos/completados",
    name: "completedChecklist",
    component: CompletedChecklist,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/analiticos/incidencias",
    name: "damagesChecklist",
    component: DamagesChecklist,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/transferencias/pedidos/:id",
    name: "transfer-detail",
    component: Transfer,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/transferencias/pedidos/:id/checklist/:event/:action",
    name: "transfer-checklist",
    component: TransferCheckList,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/transferencias/checklist-de-revision-entrega",
    name: "signChecklistTransportistTransfer",
    component: DamageSignChecklistTransportist,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/transferencias/checklist-de-revision-recibe/:type/:step",
    name: "signChecklistReceptorTransfer",
    component: DamageSignChecklistReceptor,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/incidencias/pedidos/:filter/:id",
    name: "pedido",
    component: DamageDetallePedido,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/incidencias/pedidos",
    name: "pedidos",
    component: DamagePedidos,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/incidencias/pedidos/:id/checklist/:productID/:event/:type",
    name: "checklist",
    component: DamageChecklist,
    meta: {
      requiresAuth: true
    }
  },

  {
    path: "/incidencias/albaran/:id/checklist/:checklistId/",
    name: "albaran-checklist",
    component: AlbaranChecklist,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/incidencias/checklist-de-revision-entrega",
    name: "signChecklistTransportist",
    component: DamageSignChecklistTransportist,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/incidencias/checklist-de-revision-recibe/:type/:step",
    name: "signChecklistReceptor",
    component: DamageSignChecklistReceptor,
    meta: {
      requiresAuth: true
    }
  },

  {
    path: "/incidencias/pedidos/:id/checklist/contrato",
    name: "contrato",
    component: DamageContract,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/history",
    name: "history",
    component: History,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "*",
    name: "not-found",
    component: NotFound,
    meta: {
      requiresAuth: true
    }
  }
];

const router = new Router({
  routes,
  mode: "history",
  base: process.env.BASE_URL
});

// :: Auth check before each route visit
router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(({ meta }) => meta.requiresAuth);
  const loggedIn = store.getters["user/isLogged"];
  const requiresValidAccess = to.matched.some(
    ({ meta }) => meta.requiresValidAccess
  );
  const requiresValidAccessGlobal = to.matched.some(
    ({ meta }) => meta.requiresValidAccessGlobal
  );
  const requireAdmin = to.matched.some(({ meta }) => meta.requireAdmin);
  // :: If the path requires the user be authenticated, redirect to login
  if (requiresAuth && !loggedIn) {
    return next("/login");
  } else {
    if (requireAdmin) {
      const access = store.state.user.userAccess;
      // Users view
      if (access["user-creation"]) return next();
      return next("/");
    }
    if (requiresValidAccess) {
      const access = store.state.user.userAccess;
      // Dynamic board view validation
      if (
        to.params.branchOffice == "18" &&
        access["dynamic-board-sucursal-toluca"]
      )
        return next();
      if (
        to.params.branchOffice == "19" &&
        access["dynamic-board-sucursal-aguascalientes"]
      )
        return next();
      if (
        to.params.branchOffice == "20" &&
        access["dynamic-board-sucursal-coatzacoalcos"]
      )
        return next();
      if (
        to.params.branchOffice == "21" &&
        access["dynamic-board-sucursal-cuatitlan"]
      )
        return next();
      if (
        to.params.branchOffice == "22" &&
        access["dynamic-board-sucursal-cuernavaca"]
      )
        return next();
      if (
        to.params.branchOffice == "23" &&
        access["dynamic-board-sucursal-guadalajara"]
      )
        return next();
      if (
        to.params.branchOffice == "24" &&
        access["dynamic-board-sucursal-tizayuca"]
      )
        return next();
      if (
        to.params.branchOffice == "25" &&
        access["dynamic-board-sucursal-merida"]
      )
        return next();
      if (
        to.params.branchOffice == "26" &&
        access["dynamic-board-sucursal-monterrey"]
      )
        return next();
      if (
        to.params.branchOffice == "27" &&
        access["dynamic-board-sucursal-puebla"]
      )
        return next();
      if (
        to.params.branchOffice == "28" &&
        access["dynamic-board-sucursal-salitre"]
      )
        return next();
      if (
        to.params.branchOffice == "29" &&
        access["dynamic-board-sucursal-potosi"]
      )
        return next();
      if (
        to.params.branchOffice == "31" &&
        access["dynamic-board-sucursal-silao"]
      )
        return next();
      if (
        to.params.branchOffice == "33" &&
        access["dynamic-board-sucursal-veracruz"]
      )
        return next();
      if (
        to.params.branchOffice == "36" &&
        access["dynamic-board-sucursal-chiapa"]
      )
        return next();
      if (
        to.params.branchOffice == "1" &&
        access["dynamic-board-sucurlar-corporativo"]
      )
        return next();
      // Damage view validation
      if (to.params.filter === "delivery" && access["damage-read-delivery"])
        return next();
      if (
        to.params.filter === "maintenance" &&
        access["damage-read-maintenance"]
      )
        return next();
      if (
        to.params.filter === "recollection" &&
        access["damage-read-recollection"]
      )
        return next();
      if (to.params.filter === "relocation" && access["damage-read-relocation"])
        return next();
      if (
        to.params.filter === "rented-service" &&
        access["damage-read-rentedservice"]
      )
        return next();
      if (to.params.filter === "delivery" && access["damage-write-delivery"])
        return next();
      if (
        to.params.filter === "maintenance" &&
        access["damage-write-maintenance"]
      )
        return next();
      if (
        to.params.filter === "recollection" &&
        access["damage-write-recollection"]
      )
        return next();
      if (
        to.params.filter === "relocation" &&
        access["damage-write-relocation"]
      )
        return next();
      if (
        to.params.filter === "rented-service" &&
        access["damage-write-rentedservice"]
      )
        return next();
      if (
        to.path === "carousel-add-kpi" &&
        (access["add-kpi"] || access["admin-kpi"])
      )
        return next();
      if (
        to.path === "/carousel-show-kpi" &&
        (access["show-kpi"] || access["admin-kpi"])
      )
        return next();

      return next("/");
    }

    if (requiresValidAccessGlobal) {
      const access = store.state.user.userAccess;
      if (access["dynamic-board-sucursal-global"]) return next();
      return next("/");
    }
  }
  next();
});

Vue.use(Router);

export default router;
